import { useAppDispatch, useAppSelector } from "../../context-store";
import MenuModel from "./model/MenuModel";
import styles from "./SideBar.module.css";
import Logo from "../../assets/InnerCSS/img/logos/logo.png";
import LogoSmall from "../../assets/InnerCSS/img/fav.png";
import { useHistory } from "react-router";
import React, { Fragment, useState, useEffect, MouseEvent } from "react";
import RoleScreenModel from "./model/RoleScreenModel";
import SubMenuModel from "./model/SubMenuModel";
import MenuItem from "./MenuItem";
import useIsMobile from "./useIsMobile";
import { menuActions } from "../../context-store/menu-context";

const SideBar = () => {
  let loggedInUser = useAppSelector((state) => state.authState.loggedInUser);
  const history = useHistory();
  const dispatch = useAppDispatch();
  const isMobile = useIsMobile();
  //const menuGroups: MenuModel[] = [];

  const processRoutes = () => {
    let routes: MenuModel[] = [];
    if (loggedInUser != null) {
      let mainRoutes: RoleScreenModel[] = loggedInUser.routes.filter(x => x.menuLevel === 0);
      mainRoutes.forEach(route => {
        let subRoutes = loggedInUser?.routes.filter(x => x.parentId === route.screenId).map(subRoute => {
          return {
            id: subRoute.screenName,
            title: subRoute.displayName,
            icon: subRoute.icon,
            path: subRoute.routePath
          };
        }) as SubMenuModel[];
        let objRoute: MenuModel = {
          id: route.screenName,
          title: route.displayName,
          opened: false,
          icon: route.icon,
          hasChildren: subRoutes.length > 0 ? true : false,
          path: route.routePath,
          subMenuItems: subRoutes
        };
        routes.push(objRoute);
      });
    }
    return routes;
  };

  const menuGroups: MenuModel[] = processRoutes();
  const sideBarExpanded = useAppSelector(state => state.menuState.sideBarExpanded);
  let expandCollapseClass = sideBarExpanded ? styles.sidebarExpanded : styles.sidebarCollapsed;
  let sidebarClass = `page-sidebar ${expandCollapseClass}`;
  const homeRedirect = (event: MouseEvent) => {
    event.preventDefault();
    history.push("/");
  };

  const menuClickHandler = () => {
    if (isMobile) {
      dispatch(menuActions.toggleSideBarStatus());
    }
  };

  return (
    <div className={sidebarClass}>
      {sideBarExpanded ? (
        <a className="logo-box" onClick={homeRedirect}>
          <span><img src={Logo} alt="Logo" /></span>
        </a>
      ) : (
        <a className="logo-box-small" onClick={homeRedirect}>
          <span><img src={LogoSmall} alt="Logo Small" /></span>
        </a>
      )}
      <div className="page-sidebar-inner">
        <div className="page-sidebar-menu">
          <ul className="accordion-menu">
            {menuGroups.map((menuGroup) => (
              <MenuItem key={menuGroup.id} menuItem={menuGroup} onMenuClick={menuClickHandler} />
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};
export default SideBar;